import { lazyLoad } from '../../../core/utils/loadable';

export const BusinessesDetail = lazyLoad(
  () => import('./index'),
  (module) => module.BusinessesDetail,
);
